var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "225px",
    width: "225px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#173b59",
    stroke: "#173b59",
    strokeWidth: 10.24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff0bc"
    },
    d: "M426.29,312.254c13.902,8.021,12.467,44.586,7.637,49.414H255.998l0,0H78.075 c-4.831-4.828-6.267-41.391,7.637-49.414c38.806-22.396,52.504-83.142,57.086-142.773C147.379,109.848,197.801,64.029,256,64.029 c58.201,0,108.625,45.82,113.206,105.453C373.786,229.112,387.482,289.859,426.29,312.254z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff0bc"
    },
    d: "M255.998,415.999c30.006,0,54.334-24.327,54.334-54.332h-54.334h-54.329 C201.67,391.672,225.994,415.999,255.998,415.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff0bc"
    },
    d: "M256.001,64.028c14.695,0,26.682-11.986,26.682-26.68c0-14.695-11.985-26.682-26.682-26.682 c-14.693,0-26.682,11.985-26.682,26.682C229.319,52.043,241.307,64.028,256.001,64.028z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M65.192,272.872c-3.98-4.342-10.727-4.641-15.071-0.659c-1.233,1.13-2.509,2.271-3.825,3.427 c-4.425,3.888-4.863,10.627-0.975,15.053c2.111,2.401,5.056,3.628,8.019,3.628c2.5,0,5.01-0.874,7.036-2.653 c1.431-1.257,2.817-2.498,4.156-3.726C68.876,283.963,69.172,277.215,65.192,272.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M72.339,265.417c1.856,1.293,3.979,1.913,6.083,1.913c3.373,0,6.691-1.597,8.765-4.575 c17.563-25.238,20.206-50.18,23.704-95.725c0.452-5.874-3.943-11.002-9.819-11.453c-5.891-0.451-11.001,3.946-11.452,9.818 c-3.296,42.902-5.519,64.445-19.943,85.174C66.309,255.404,67.503,262.053,72.339,265.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M398.336,147.832c1.069,5.012,5.495,8.446,10.422,8.446c0.736,0,1.484-0.077,2.234-0.237 c5.76-1.228,9.438-6.894,8.208-12.655c-0.439-2.063-0.925-4.142-1.442-6.177c-1.452-5.709-7.259-9.162-12.966-7.71 c-5.709,1.452-9.161,7.257-7.709,12.966C397.532,144.233,397.954,146.039,398.336,147.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M465.484,275.453c-31.224-25.969-38.083-51.269-42.433-101.768 c-0.507-5.87-5.679-10.221-11.543-9.711c-5.869,0.506-10.217,5.674-9.71,11.542c4.698,54.531,13.383,85.849,50.046,116.339 c1.994,1.658,4.411,2.466,6.815,2.466c3.06,0,6.098-1.31,8.208-3.846C470.632,285.945,470.013,279.22,465.484,275.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M441.904,314.239c-0.142-0.284-0.295-0.56-0.463-0.828c-2.579-4.6-5.867-8.114-9.823-10.396 c-28.787-16.613-46.208-61.816-51.781-134.352c-4.133-53.8-42.494-97.895-92.406-111.187c3.738-5.813,5.915-12.72,5.915-20.129 C293.347,16.754,276.593,0,255.998,0c-20.592,0-37.346,16.754-37.346,37.348c0,7.409,2.179,14.315,5.915,20.129 c-49.912,13.291-88.273,57.387-92.408,111.187c-5.573,72.536-22.994,117.738-51.779,134.352 c-8.337,4.811-13.755,15.027-15.665,29.548c-1.239,9.426-1.621,29.217,5.817,36.65c2,1.999,4.713,3.122,7.539,3.122h113.823 c5.104,30.781,31.9,54.332,64.107,54.332c32.206,0,59.001-23.551,64.107-54.332h113.821c2.827,0,5.539-1.123,7.539-3.122 c7.44-7.437,7.056-27.234,5.814-36.663C446.33,325.338,444.513,319.191,441.904,314.239z M255.998,21.333 c8.831,0,16.015,7.184,16.015,16.015c0,8.83-7.183,16.014-16.015,16.014c-8.829,0-16.013-7.184-16.013-16.014 C239.986,28.517,247.17,21.333,255.998,21.333z M255.998,405.332c-20.398,0-37.569-14.061-42.341-32.998h84.681 C293.567,391.272,276.396,405.332,255.998,405.332z M426.234,351.002H85.764c-0.442-3.487-0.675-8.542-0.067-14.235 c1.021-9.532,3.756-14.356,5.346-15.275c35.748-20.631,56.156-70.087,62.387-151.194c4.118-53.609,49.173-95.603,102.568-95.603 c53.396,0,98.45,41.995,102.568,95.603c2.998,39.019,9.285,70.691,18.975,95.374h-40.1c-5.89,0-10.667,4.775-10.667,10.667 c0,5.891,4.777,10.667,10.667,10.667h50.323c4.822,8.249,10.221,15.35,16.198,21.333H297.598c-5.889,0-10.667,4.775-10.667,10.667 c0,5.891,4.778,10.667,10.667,10.667h127.454c0.513,1.988,0.953,4.338,1.248,7.093 C426.909,342.459,426.675,347.515,426.234,351.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M362.663,490.667l-213.333-0.004c-5.889,0-10.667,4.775-10.667,10.667 c0,5.89,4.775,10.667,10.667,10.667L362.663,512c5.891,0,10.667-4.775,10.667-10.667 C373.329,495.443,368.555,490.667,362.663,490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#173b59"
    },
    d: "M259.198,308.339h-6.4c-5.891,0-10.667,4.775-10.667,10.667c0,5.891,4.775,10.667,10.667,10.667h6.4 c5.889,0,10.667-4.775,10.667-10.667C269.865,313.115,265.089,308.339,259.198,308.339z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell);
export default __webpack_public_path__ + "static/media/notification-bell.e766ecee.svg";
export { ForwardRef as ReactComponent };